/**
 * Invoice Constants - Fatura durumları ve ödeme yöntemleri için seçenekler
 */

// Fatura durumları
export const INVOICE_STATUS_OPTIONS = [
  { value: "DRAFT", label: "Taslak", color: "default" },
  { value: "SENT", label: "Gönderildi", color: "processing" },
  { value: "PAID", label: "Ödendi", color: "success" },
  { value: "CANCELLED", label: "İptal Edildi", color: "error" },
  { value: "OVERDUE", label: "Vadesi Geçmiş", color: "warning" },
];

// Ödeme yöntemleri
export const PAYMENT_METHOD_OPTIONS = [
  { value: "CASH", label: "Nakit" },
  { value: "BANK_TRANSFER", label: "Banka Transferi" },
  { value: "CREDIT_CARD", label: "Kredi Kartı" },
  { value: "OTHER", label: "Diğer" },
];

/**
 * Fatura durumuna göre badge bilgisi döndürür
 * @param {string} status - Durum değeri (DRAFT, SENT, PAID, CANCELLED, OVERDUE)
 * @returns {{ color: string, text: string }}
 */
export const getInvoiceStatusInfo = (status) => {
  const option = INVOICE_STATUS_OPTIONS.find((opt) => opt.value === status);

  if (option) {
    return { color: option.color, text: option.label };
  }

  return { color: "error", text: "Bilinmiyor" };
};

/**
 * Fatura durum seçeneklerini Select component için formatlar
 * @returns {Array<{ value: string, label: string }>}
 */
export const getInvoiceStatusOptions = () => {
  return INVOICE_STATUS_OPTIONS.map(({ value, label }) => ({ value, label }));
};

/**
 * Ödeme yöntemi seçeneklerini Select component için formatlar
 * @returns {Array<{ value: string, label: string }>}
 */
export const getPaymentMethodOptions = () => {
  return PAYMENT_METHOD_OPTIONS.map(({ value, label }) => ({ value, label }));
};

/**
 * Ödeme yöntemi label'ını döndürür
 * @param {string} method - Ödeme yöntemi
 * @returns {string}
 */
export const getPaymentMethodLabel = (method) => {
  const option = PAYMENT_METHOD_OPTIONS.find((opt) => opt.value === method);
  return option ? option.label : method || "-";
};

// E-Fatura durumları
export const EINVOICE_STATUS_OPTIONS = [
  { value: "NONE", label: "Gönderilmedi", color: "default" },
  { value: "QUEUED", label: "Kuyrukta", color: "processing" },
  { value: "SENT", label: "Gönderildi", color: "blue" },
  { value: "ACCEPTED", label: "Kabul Edildi", color: "success" },
  { value: "REJECTED", label: "Reddedildi", color: "error" },
  { value: "CANCELLED", label: "İptal Edildi", color: "warning" },
];

// Fatura tipi seçenekleri
export const INVOICE_TYPE_OPTIONS = [
  { value: "SATIS", label: "Satış Faturası" },
  { value: "IADE", label: "İade Faturası" },
];

// Fatura profili seçenekleri
export const INVOICE_PROFILE_OPTIONS = [
  { value: "TEMELFATURA", label: "Temel Fatura" },
  { value: "TICARIFATURA", label: "Ticari Fatura" },
];

// Birim kodu seçenekleri (GİB UN/ECE Rec 20)
export const UNIT_CODE_OPTIONS = [
  { value: "ADET", label: "Adet" },
  { value: "LTR", label: "Litre" },
  { value: "KGM", label: "Kilogram" },
  { value: "MTR", label: "Metre" },
  { value: "M2", label: "Metrekare" },
  { value: "M3", label: "Metreküp" },
  { value: "TON", label: "Ton" },
  { value: "PAKET", label: "Paket" },
  { value: "KUTU", label: "Kutu" },
  { value: "SET", label: "Set" },
  { value: "SAAT", label: "Saat" },
  { value: "GUN", label: "Gün" },
  { value: "GRAM", label: "Gram" },
];

/**
 * E-fatura durumuna göre badge bilgisi döndürür
 * @param {string} status - E-fatura durum değeri
 * @returns {{ color: string, text: string }}
 */
export const getEInvoiceStatusInfo = (status) => {
  const option = EINVOICE_STATUS_OPTIONS.find((opt) => opt.value === status);
  if (option) {
    return { color: option.color, text: option.label };
  }
  return { color: "default", text: "-" };
};

/**
 * Birim kodu label'ını döndürür
 * @param {string} code - Birim kodu
 * @returns {string}
 */
export const getUnitCodeLabel = (code) => {
  const option = UNIT_CODE_OPTIONS.find((opt) => opt.value === code);
  return option ? option.label : code || "Adet";
};
